import { Action } from '@ngrx/store';
import { TopServiceModel } from './model';

export enum ActionTypes {
  FAILURE = '[TopService] Failure',

  GET_ALL_REQUEST = '[TopService] GetAll Request',
  GET_ALL_SUCCESS = '[TopService] GetAll Success',

  UP_PRIORITY_REQUEST = '[TopService] UpPriority Request',
  DOWN_PRIORITY_REQUEST = '[TopService] DownPriority Request',

  SAVE_REQUEST = '[TopService] Save Request',
  SAVE_SUCCESS = '[TopService] Save Success',

  DELETE_REQUEST = '[TopService] Delete Request',
  DELETE_SUCCESS = '[TopService] Delete Success',

  SYNC_REQUEST = '[TopService] Sync Request',
}

export class Failure implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class GetAllRequest implements Action {
  readonly type = ActionTypes.GET_ALL_REQUEST;
  constructor() {}
}

export class GetAllSuccess implements Action {
  readonly type = ActionTypes.GET_ALL_SUCCESS;
  constructor(public entities: TopServiceModel[]) {}
}

export class UpPriorityRequest implements Action {
  readonly type = ActionTypes.UP_PRIORITY_REQUEST;
  constructor(public entity: TopServiceModel) {}
}

export class DownPriorityRequest implements Action {
  readonly type = ActionTypes.DOWN_PRIORITY_REQUEST;
  constructor(public entity: TopServiceModel) {}
}

export class SaveRequest implements Action {
  readonly type = ActionTypes.SAVE_REQUEST;
  constructor(public entity: TopServiceModel) {}
}

export class SaveSuccess implements Action {
  readonly type = ActionTypes.SAVE_SUCCESS;
  constructor(public entity: TopServiceModel) {}
}

export class DeleteRequest implements Action {
  readonly type = ActionTypes.DELETE_REQUEST;
  constructor(public id: number) {}
}

export class DeleteSuccess implements Action {
  readonly type = ActionTypes.DELETE_SUCCESS;
  constructor(public entity: TopServiceModel) {}
}

export class SyncRequest implements Action {
  readonly type = ActionTypes.SYNC_REQUEST;
  constructor() {}
}

export type Actions =
  | Failure
  | GetAllRequest
  | GetAllSuccess
  | UpPriorityRequest
  | DownPriorityRequest
  | SaveRequest
  | SaveSuccess
  | DeleteRequest
  | DeleteSuccess
  | SyncRequest;
